 import { DomainBase } from "./DomainBase";
 
 export  class ProductPos extends DomainBase {
    constructor() {
    super();
      
       
       this.ProdCode="";
       this.Description1="";
     this.ShortDescription="";
     this.ShortName="";
      this.CategoryID="";
     this.SubGroupID="";
     this.ItemTypeID="";
      this.StockTypeID="";
     this.RetailRate=0;
      this.WSRate=0;
       this.AvgCost=0;
       this.MinPrice=0;
      this.UnitID="";
       this.ManufactureID="";
       this.MinQty=0;
       this.ReorderLevel='';
      this.MaxQty=0;
      this.ReorderQty=0;
      this.TaxID='';
      this.TaxPercentage=0;
     this.IsMenuItem="";
       this.IsSalesTaxIncludedInPrice=0;
       this.IsPurchaseTaxIncludedInPrice=0;
       this.CreatedBy='';
       this.ModifiedDate=null;
       this.Ubc="";
       this.Sbc=""
      this.image='';
      this.productImagesList=[];
      this. Branch =null;
      this.isActive=false;       
  }
}

